var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row align-items-center mt-3" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("h3", [_vm._v("Allgemein")]),
            _vm._v(" "),
            _c("p", [_vm._v("\n              Stand: 30.06.2021\n          ")]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("h3", [_vm._v("1. Sinn und Zweck der Plattform")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die aQuadrat - Dr Meyer, Krombholz, Heinze, Leuchtenstern, Romer GbR bietet eine Plattform für Arbeitnehmer*innen und die Arbeitgeber*innen zum Zwecke des gegenseitigen Austauschs Unternehmens- und Person-bezogener Informationen im Hinblick auf die Anbahnung eines Angestelltenverhältnisses:"
              ),
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("h3", [_vm._v("2. Inhalt und Art der Daten")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Zum Zwecke der Vertragserfüllung werden folgende Daten im Internet erhoben:"
              ),
            ]),
            _vm._v(" "),
            _c("h4", [_vm._v("2.1 Daten des Nutzers a")]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("h4", [_vm._v("2.2 Daten des Nutzers b")]),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Wir weisen ausdrücklich darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch Dritte geschützt werden kann. "
              ),
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Datenverarbeitung")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Zum Zwecke der Vertragserfüllung verarbeitet die Plattform personen- und unternehmensbezogene Daten im Rahmen der vertraglichen Vereinbarungen mit den „Kunden“ (= Nutzer a und Nutzer b). Diese vertraglichen Vereinbarungen berücksichtigen die für Deutschland geltende EU-Datenschutzgrundverordnung (DSGVO). "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Der Verständlichkeit der Datenverarbeitung dienen folgende Begriffserklärungen"
              ),
            ]),
            _vm._v(" "),
            _c("h4", [_vm._v("3.1 Begriffserklärungen")]),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _vm._m(9),
            _vm._v(" "),
            _vm._m(10),
            _vm._v(" "),
            _vm._m(11),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Anmerkung: Behörden, die im Rahmen eines bestimmten Untersuchungsauftrags nach dem Unionsrecht oder dem Recht der Mitgliedstaaten möglicherweise personenbezogene Daten erhalten, gelten jedoch nicht als Empfänger; die Verarbeitung dieser Daten durch die genannten Behörden erfolgt im Einklang mit den geltenden Datenschutzvorschriften gemäß den Zwecken der Verarbeitung."
              ),
            ]),
            _vm._v(" "),
            _vm._m(12),
            _vm._v(" "),
            _c("h4", [
              _vm._v(
                "3.2 Spezifikation des Datenschutzes bei der Datenverarbeitung"
              ),
            ]),
            _vm._v(" "),
            _c("h5", [_vm._v("3.2.1 Verarbeitung der Daten des Nutzers a")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Diese Daten sind für alle Nutzerinnen und Nutzer der Plattform immer und uneingeschränkt sichtbar. Eine Ausnahme können die Unternehmensspezifischen Anforderungsprofile bilden. Über deren Sichtbarkeit entscheidet Nutzer a. "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die Daten von Nutzer a können entsprechend den vertraglichen Vereinbarungen vom Unternehmen jederzeit verändert oder ergänzt werden. Die Berücksichtigung markenschutz- und wettbewerbsrechtlicher Vorgaben hierbei liegt im Verantwortungsbereich des Unternehmens. Ihre Speicherdauer endet mit dem Erlöschen des Nutzerkontos."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Rechtsgrundlage für die Verarbeitung dieser Daten ist Art. 6 I b) DSGVO"
              ),
            ]),
            _vm._v(" "),
            _c("h5", [_vm._v("3.2.2 Verarbeitung der Daten des Nutzers b")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die Verarbeitung der Daten des Nutzers b erfolgt gemäß Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO). Es sind technische und organisatorische Maßnahmen umgesetzt, um einen möglichst lückenlosen Schutz der verarbeiteten personenbezogenen Daten sicherzustellen. Datenübertragungen über das Internet können aber grundsätzlich Sicherheitslücken enthalten. Es kann ein 100 %iger Schutz nicht gewährleistet werden."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "In Ausnahmenfällen gemäß Art 2 d DSGVO (= bei der rechtlichen Verpflichtung zur Herausgabe bestimmter Daten an die zuständigen Behörden zum Zwecke der Verhütung, Ermittlung, Aufdeckung oder Verfolgung von Straftaten oder der Strafvollstreckung, einschließlich des Schutzes vor und der Abwehr von Gefahren für die öffentliche Sicherheit, oder zur Durchsetzung der Rechte am geistigen Eigentum) erfolgt diese Herausgabe unter gleichzeitiger Information der betroffenen Kundin/des betroffenen Kunden, sofern die gesetzlichen Vorgaben dieses nicht explizit verbieten."
              ),
            ]),
            _vm._v(" "),
            _vm._m(13),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Rechtsgrundlage für die Verarbeitung dieser Daten sind ist Art. 6 I a und b DSGVO."
              ),
            ]),
            _vm._v(" "),
            _vm._m(14),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die Speicherdauer dieser Daten endet mit dem Erlöschen des Nutzerkontos."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Rechtsgrundlage für die Verarbeitung dieser Daten sind Art. 5 a bis d, sowie 6 I a und b DSGVO."
              ),
            ]),
            _vm._v(" "),
            _c("h5", [
              _vm._v("3.2.3 Die Kommunikation zwischen Plattform und Nutzer"),
            ]),
            _vm._v(" "),
            _vm._m(15),
            _vm._v(" "),
            _vm._m(16),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Unsere Plattform setzt auf Ihrer Seite Cookies ein. Hierbei handelt es sich um kleine Dateien, die der Browser automatisch erstellt und die auf dem Nutzer-Endgerät (Laptop, Tablet, Smartphone o.ä.) gespeichert werden, wenn der Nutzer die Plattform besucht. Cookies richten auf dem Nutzer-Endgerät keinen Schaden an, enthalten keine Viren, Trojaner oder sonstige Schadsoftware. In dem Cookie werden Informationen abgelegt, die sich jeweils im Zusammenhang mit dem spezifisch eingesetzten Endgerät ergeben. Der Einsatz von Cookies dient einerseits dazu, die Nutzung der Plattform für den Nutzer angenehmer zu gestalten. Sie werden z.B. eingesetzt, um dem Nutzer die Möglichkeit zu geben, die Plattform für einige Zeit zu verlassen und später an der gleichen Stelle fortzufahren. Diese werden nach Beendigung des Vertragsverhältnisses automatisch gelöscht."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die auf unserer Webseite veröffentlichten Links werden von uns mit größtmöglicher Sorgfalt recherchiert und zusammengestellt. Wir haben jedoch keinen Einfluss auf die aktuelle und zukünftige Gestaltung und Inhalte der verlinkten Seiten. Wir sind nicht für den Inhalt der verknüpften Seiten verantwortlich und machen uns den Inhalt dieser Seiten ausdrücklich nicht zu Eigen. Für illegale, fehlerhafte oder unvollständige Inhalte sowie für Schäden, die durch die Nutzung oder Nichtnutzung der Informationen entstehen, haftet allein der Anbieter der Web-Site, auf die verwiesen wurde. Die Haftung desjenigen, der lediglich auf die Veröffentlichung durch einen Link hinweist, ist ausgeschlossen. Für fremde Hinweise sind wir nur dann verantwortlich, wenn wir von ihnen, d.h. auch von einem eventuellen rechtswidrigen bzw. strafbaren Inhalt, positive Kenntnis haben und es uns technisch möglich und zumutbar ist, deren Nutzung zu verhindern."
              ),
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("5. Google Sign-In")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'Nutzer der Gruppe b können sich sich zur Erstellung eines Kundenkontos bzw. zur Registrierung für Google Sign-In entscheiden. Diese wird von Google LLC., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA ("Google") betrieben. Im Rahmen der sog. Single Sign On können sich diese Nutzer anmelden, falls sie über ein Google-Profil verfügen. Zugangspunkte "Google Sign-In" bzw. "Mit Google registrieren" auf unserer Internetseite erkennen Sie an einem roten Button mit dem Google-Logo und der Aufschrift "Google Sign-In" bzw. "Mit Google registrieren" bzw. "Mit Google anmelden" bzw. "Anmeldung mit G".'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Über die Verwendung dieses Google-Buttons auf unserer Website haben Sie die Möglichkeit, sich mittels Ihrer Google-Nutzerdaten auf unserer Website einzuloggen bzw. zu registrieren. Ausschließlich dann, wenn Sie vor dem Anmeldeprozess auf Basis eines entsprechenden Hinweises über den Austausch von Daten mit Google Ihre ausdrückliche Einwilligung gemäß Art. 6 Abs. 1 lit. a) DSGVO erteilen, erhalten wir bei Verwendung des Google- Buttons von Google, abhängig von Ihren persönlich getroffenen Datenschutzeinstellungen bei Google, die in Ihrem Profil hinterlegten allgemeinen und öffentlich zugänglichen Informationen. Zu diesen Informationen gehören hierbei die Nutzer-ID, der Name, das Profilbild, das Alter und das Geschlecht."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'Wir weisen darauf hin, dass es nach Änderungen der Datenschutzbedingungen und Nutzungsbedingungen von Google bei Erteilung der Einwilligung auch zu einer Übertragung Ihrer Profilbilder, der Nutzer-IDs Ihrer Freunde und der Freundesliste kommen kann, wenn diese in Ihren Privatsphäreeinstellungen bei Google als "öffentlich" markiert wurden. Die von Google übermittelten Daten werden bei uns zur Erstellung eines Benutzerkontos mit den notwendigen Daten, falls diese von Ihnen bei Google dazu freigegeben wurden (Anrede, Vorname, Nachname, Adressdaten, Land, E-Mail Adresse, Geburtsdatum), gespeichert und verarbeitet. Umgekehrt können auf Basis Ihrer Einwilligung Daten (z.B. Informationen zu Ihrem Surf- bzw. Kaufverhalten) von uns an Ihr Google-Profil übertragen werden.'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die erteilte Einwilligung kann jederzeit durch eine Nachricht an den zu Beginn dieser Erklärung genannten Verantwortlichen widerrufen werden."
              ),
            ]),
            _vm._v(" "),
            _vm._m(17),
            _vm._v(" "),
            _vm._m(18),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Wenn Sie nicht möchten, dass Google die über unseren Webauftritt gesammelten Daten unmittelbar Ihrem Google-Profil zuordnet, müssen Sie sich vor Ihrem Besuch unserer Website bei Google ausloggen."
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("6. Nutzerrechte")]),
            _vm._v(" "),
            _vm._m(19),
            _vm._v(" "),
            _c("h2", [_vm._v("7. Datensicherheit")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um eine 256 Bit Verschlüsselung. Falls Ihr Browser keine 256-Bit Verschlüsselung unterstützt, greifen wir stattdessen auf 128-Bit v3 Technologie zurück. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, erkennen Sie an der geschlossenen Darstellung des Schüssel- beziehungsweise Schloss-Symbols in der unteren Statusleiste Ihres Browsers."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Wir bedienen uns im Übrigen geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert."
              ),
            ]),
            _vm._v(" "),
            _c("h2", [
              _vm._v("Aktualität und Änderung dieser Datenschutzerklärung"),
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v(
                  "Durch die Weiterentwicklung der Plattform oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf der Website unter "
                ),
                _c("router-link", { attrs: { to: "/datenschutz" } }, [
                  _vm._v("Datenschutz"),
                ]),
                _vm._v(" abgerufen und ausgedruckt werden."),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [_vm._v(" ")]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h2", [_vm._v("Datenschutzerklärung")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v("Verantwortlich für die Verarbeitung personbezogener Daten:"),
      ]),
      _c("br"),
      _vm._v("\n          Florian Leuchtenstern"),
      _c("br"),
      _vm._v("\n          Beim Wahlbaum 73"),
      _c("br"),
      _vm._v("\n          90453 Nürnberg"),
      _c("br"),
      _vm._v("\n          Telefon: + 49 (0) 911 92 86 76 52"),
      _c("br"),
      _vm._v("\n          Email: Florian@Leuchtenstern.com"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Datenschutzbeauftragter:")]),
      _c("br"),
      _vm._v("\n          Florian Leuchtenstern"),
      _c("br"),
      _vm._v("\n          Beim Wahlbaum 73"),
      _c("br"),
      _vm._v("\n          90453 Nürnberg"),
      _c("br"),
      _vm._v("\n          Telefon: + 49 (0) 911 92 86 76 52"),
      _c("br"),
      _vm._v("\n          Email: Florian@Leuchtenstern.com"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Unternehmen")]),
      _vm._v(" (in Folgenden „Nutzer a“ genannt)"),
      _c("br"),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n              definieren auf der Plattform ihre für Mitarbeiterinnen und Mitarbeiter je nach Funktion im Unternehmen (Auszubildende, Fachkräfte, Führungskräfte) gültigen "
          ),
          _c("strong", [_vm._v("Anforderungsprofile")]),
          _vm._v(",\n            "),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "präsentieren das Unternehmen auf der Plattform anhand eines "
          ),
          _c("strong", [_vm._v("Firmenprofils")]),
          _vm._v(
            " allgemein, insbesondere für jene Personengruppe, bei der Personalbedarf besteht (offene Stellen) und deren Eignungsprofil dem Anforderungsprofil des Unternehmens entspricht."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Arbeitnehmer*innen")]),
      _vm._v(
        " (Personen im Vorfeld des Berufslebens oder auf der Suche nach einer neuen Arbeits-/Ausbildungsstelle; im Folgenden genannt: „Nutzer b“)\n        "
      ),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n            ermitteln auf der Plattform ihre persönlichen Stärken im beruflichen und privaten Kontext ("
          ),
          _c("strong", [_vm._v('"persönliches Stärke-/Eignungsprofil"')]),
          _vm._v("),\n          "),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n            erhalten auf der Plattform "),
          _c("strong", [_vm._v("Zugang und Kontakt")]),
          _vm._v(
            " zu den Firmenprofilen jener Unternehmen, wo Anforderungs- und persönliches Eignungsprofil einander entsprechen.\n          "
          ),
        ]),
      ]),
      _vm._v(
        "\n          Die Details der Nutzung dieser Plattform regelt ein spezieller "
      ),
      _c("strong", [_vm._v("Nutzungsvertrag")]),
      _vm._v(".\n        "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v("\n            Kontaktdaten\n            "),
        _c("ul", [
          _c("li", [_vm._v("Name")]),
          _vm._v(" "),
          _c("li", [_vm._v("Branche")]),
          _vm._v(" "),
          _c("li", [_vm._v("Adresse, Telefon, Email")]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n            Anforderungsprofile je nach Funktion im Unternehmen (Auszubildende, Fachkräfte, Führungskräfte)\n          "
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n            Daten, die das Unternehmen entsprechend den vertraglichen Vereinbarungen unter dem Titel „Über Uns“ bereitstellt \n          "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v("Zugangsdaten\n            "),
        _c("ul", [
          _c("li", [_vm._v("Login-E-Mail-Adresse")]),
          _vm._v(" "),
          _c("li", [_vm._v("Passwort")]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Persönliche Daten")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("Name")]),
        _vm._v(" "),
        _c("li", [_vm._v("Vorname")]),
        _vm._v(" "),
        _c("li", [_vm._v("Adresse, Telefon, Email")]),
        _vm._v(" "),
        _c("li", [_vm._v("Zeit im Beruf")]),
        _vm._v(" "),
        _c("li", [_vm._v("Zeit als Führungskraft")]),
        _vm._v(" "),
        _c("li", [_vm._v("Aktueller Berufstitel")]),
        _vm._v(" "),
        _c("li", [_vm._v("Bildungsabschluss")]),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Daten, die der Berechnung der persönlichen Stärken im beruflichen und privaten Kontext des Nutzers b dienen („persönliches Stärke-/Eignungsprofil“)."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("Rahmendaten zu Arbeitsstellen\n            "),
        _c("ul", [
          _c("li", [_vm._v("Jobtitel")]),
          _vm._v(" "),
          _c("li", [_vm._v("Ort der Arbeitstelle")]),
          _vm._v(" "),
          _c("li", [_vm._v("Umkreis um den Arbeitsort")]),
          _vm._v(" "),
          _c("li", [_vm._v("Wunschgehalt")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Es handelt sich hierbei um Angaben des Nutzers b zu \n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v("dem bisherigen schulischen und beruflichen Werdegang"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Vorlieben für einen Beruf / eine Berufsausbildung bzw. Ausbildungsstelle"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Selbstauskünfte zum außerberuflichen Umfeld (Hobbies …)"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Personenbezogene Daten")]),
      _vm._v(" sind alle Informationen, die sich auf Nutzer b beziehen."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Verarbeitung")]),
      _vm._v(
        " ist jeder mit Hilfe automatisierter Verfahren ausgeführter Vorgang im Zusammenhang mit personenbezogenen Daten: \n          "
      ),
      _c("ul", [
        _c("li", [_vm._v("Datenerhebung ")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Verfahren zur Ermittlung des persönlichen Stärke-/Eignungsprofils "
          ),
          _c("strong", [_vm._v("(nicht Profiling!)")]),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Verfahren zur Ermittlung der Entsprechung von persönlichem Stärke-/Eignungsprofil und Anforderungsprofi"
          ),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Datenlöschung")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Verantwortlicher")]),
      _vm._v(
        " ist die von aquadrat – Dr Meyer, Krombholz, Heinze, Leuchtenstern, Romer GbR als verantwortlich für die Verarbeitung personenbezogener Daten ausgewiesene natürliche oder juristische Person."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Empfänger:")]),
      _vm._v(
        " Nutzer a und Nutzer b im Rahmen der vertraglichen Vereinbarungen."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Einwilligung:")]),
      _vm._v(
        " Jede freiwillig für den jeweiligen Fall unmissverständlich abgegebene Willensbekundung in Form einer Erklärung oder einer sonstigen eindeutigen bestätigenden Handlung, mit der Nutzer b zu verstehen gibt, dass er mit der Verarbeitung der ihn betreffenden personenbezogenen Daten einverstanden ist."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Die Zugangsdaten")]),
      _vm._v(
        " sind für Dritte nicht einsehbar. Die Weitergabe an Dritte (Behörden) erfolgt nur unter dem o.g. gesetzlichen Zwang. Ihre Speicherdauer endet mit dem Erlöschen des Nutzerkontos."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Die Daten für die Berechnung des persönlichen Stärke-/Eignungsprofils"
        ),
      ]),
      _vm._v(
        " sind für Dritte nicht einsehbar. Sie werden ausschließlich für die Berechnung des persönlichen Stärke-/Eignungsprofils verwendet. Sie dienen in keiner Weise einer als „Profiling“ zu verstehenden Bewertung der Person. Die Weitergabe an Dritte (Behörden) erfolgt nur unter dem o.g. gesetzlichen Zwang. Das aus diesen Daten errechnete persönliche Stärke-/Eignungsprofil ergeht ausschließlich als Rückmeldung an den jeweiligen Nutzer b. Es bleibt in seinem Ermessen, aus dem Vergleich mit den Anforderungsprofilen der Nutzer a mit diesen in Kontakt zu treten."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Beim Aufrufen der Plattform werden durch den auf dem Nutzer-Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server der Plattform gesendet. Diese Informationen werden temporär in einem sog. Logfile gespeichert. Folgende Informationen werden dabei ohne Zutun des Nutzers erfasst und bis zur automatisierten Löschung gespeichert:\n          "
      ),
      _c("ul", [
        _c("li", [_vm._v("IP-Adresse des anfragenden Rechners")]),
        _vm._v(" "),
        _c("li", [_vm._v("Datum und Uhrzeit des Zugriffs")]),
        _vm._v(" "),
        _c("li", [_vm._v("Name und URL der abgerufenen Datei")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Website, von der aus der Zugriff erfolgt (Referrer-URL),"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "verwendeter Browser und ggf. das Betriebssystem des Rechners sowie der Name des Access-Providers des Nutzers"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Die genannten Daten werden zu folgenden Zwecken verarbeitet:\n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Gewährleistung eines reibungslosen Verbindungsaufbaus der Plattform,"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Gewährleistung einer komfortablen Nutzung der Plattform,"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Auswertung der Systemsicherheit und -stabilität sowie"),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("zu weiteren administrativen Zwecken.")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Zweck und Umfang der Datenerhebung und die weitere Verarbeitung und Nutzung der Daten durch Google sowie Ihre diesbezüglichen Rechte und Einstellungsmöglichkeiten zum Schutz Ihrer Privatsphäre entnehmen Sie bitte den Datenschutzhinweisen von Google: "
      ),
      _c(
        "a",
        { attrs: { href: "https://www.google.de/intl/de/policies/privacy/" } },
        [_vm._v("https://www.google.de/intl/de/policies/privacy/")]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        'Die Nutzungsbedingungen für die Verwendung von "Google Sign-In" bzw. "Mit Google registrieren" können Sie hier einsehen: '
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.google.de/intl/de/policies/terms/regional.html",
          },
        },
        [_vm._v("https://www.google.de/intl/de/policies/terms/regional.html")]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Nutzer der Plattform haben das Recht:\n          "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "gemäß Art. 15 DSGVO Auskunft über ihre personenbezogenen Daten zu verlangen. Insbesondere können sie Auskunft über die geplante Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch, das Bestehen eines Beschwerderechts, zu verlangen"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "gemäß Art. 17 DSGVO die Löschung ihrer gespeicherten personenbezogenen Daten zu verlangen, soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung ihrer personenbezogenen Daten zu verlangen, soweit dies nicht auf die Auflösung des Nutzervertrags hinausläuft. In letzterem Fall entspricht das Verlangen nach Einschränkung der Vertragsauflösung"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "gemäß Art. 20 DSGVO die personenbezogenen Daten, sowie das Ergebnis der Verarbeitung in einem strukturierten, gängigen und maschinenlesebaren Format zu erhalten und/oder die Übermittlung an anderen Personen zu verlangen"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "gemäß Art. 7 Abs. 3 DSGVO ihre einmal erteilte Einwilligung jederzeit zu widerrufen. Dies hat zur Folge, dass die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht mehr fortgeführt wird"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }